export default __webpack_public_path__ + "static/media/3.55246037.png";